import { successLoader } from '../../Redux/_actions/loader.action';
import Cookies from 'cookies-js';
import { utilityBaseURL } from '../config/apiGateway';
import { DOCUMENT_ENDPOINT } from '../config/apiEndPoints';
import store from '../../Redux/_helpers/store';
const pdfURL = utilityBaseURL + DOCUMENT_ENDPOINT + "?documentPath=";
const DownloadFile = function (path, fileName) {
    //start loader
    store.dispatch(successLoader(false));
    const testAccess = Cookies.get('_msAL');
    fetch(pdfURL + path, {
        method: 'GET',
        headers: {
            Authorization: 'Bearer' + ` ${testAccess}`,
            'x-cc-trace-id': "123"
        }
    })
        .then(resp => resp.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            let ext = path.split('.');
            ext = ext[ext.length - 1].split("'")
            ext = ext[0];
            console.log('ext', ext);
            a.download = `${fileName}.${ext}`;
            document.body.appendChild(a);
            a.click();
            //end loader
            store.dispatch(successLoader(true));
            window.URL.revokeObjectURL(url);
        })
        .catch(() => console.log('error'));
}
export default DownloadFile;